module.exports = __webpack_public_path__ + "media/packs/images/flags/BE-73e0aa6bff2995f6e61c1987c8db1ab2.png";